var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1158 10H10.8842C10.3958 10 10 10.3958 10 10.8842V25.1158C10 25.6042 10.3958 26 10.8842 26H18.5474V19.8246H16.4561V17.3909H18.5361V15.614C18.5361 13.5453 19.7965 12.4196 21.6407 12.4196C22.2667 12.4225 22.8926 12.4561 23.5158 12.5263V14.6849H22.2414C21.2393 14.6849 21.0456 15.1593 21.0456 15.8582V17.4021H23.4456L23.134 19.8246H21.0456V26H25.1158C25.6042 26 26 25.6042 26 25.1158V10.8842C26 10.3958 25.6042 10 25.1158 10Z",
    fill: "#959EA8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMail);
export default __webpack_public_path__ + "static/media/facebook_mail.4a21ea2f5f96a23f42da02ede5ac4477.svg";
export { ForwardRef as ReactComponent };